export enum OrderSortType {
    CREATION = "creation_ts",
    ID = "id",
    LAST_UPDATE_TS = "last_update_ts"
}
